import { PaxType } from '@booking/entities/pax-type';

export type SeatMap = Readonly<{
  Cabins: CabinSeatMap[],
  Flight: FlightSeatMap,
  Passengers: PassengersSeatMap[],
  Seats: PassengersSeats[],
  ItineraryId: number,
  FlightIdx: number,
  AvailableSeats: number,
  SearchId: string;
}>;

export type FlightSeatMap = Readonly<{
  Carrier: string,
  Destination: string,
  Origin: string,
  DepartureDate: string
}>;

export type ColumnSeatMap = Readonly<{
  Name: string,
  Position: PositionTypes
}>;

export type CabinSeatMap = Readonly<{
  Rows: DataRowSeatMap[],
  Wings: DataWingSeatMap[],
  TotalRows: number,
  FirstRow: number,
  LastRow: number
}>;

export type DataWingSeatMap = Readonly<{
  WingType?: WingTypes,
  Type: RowDataTypes
}>;

export type DataRowSeatMap = Readonly<{
  Type: RowDataTypes,
  Data: DataColumnsSeatMap[] | CabinTitleSeatMap | RowSeatsMap[]
}>;

export type DataColumnsSeatMap = Readonly<{
  Letter: string,
  Position: PositionTypes
}>;

export type CabinTitleSeatMap = Readonly<{
  Title: string,
  Type: CabinTypes
}>;

export type RowSeatsMap = Readonly<{
  RowNumber: number,
  Seats: RowDataSeatsMap[]
}>;

export type RowDataSeatsMap = Readonly<{
  Chargeable: boolean,
  ExitRow: boolean,
  Inoperative: boolean,
  Location: PositionTypes,
  NoInfant: boolean,
  NotSeat: boolean,
  Number: string,
  Occupied: boolean,
  Premium: boolean,
  RestrictedRecline: boolean,
  Selected?: boolean,
  Preview?: boolean,
  ErrorSelected?: boolean
}>;

export type PassengersSeatMap = Readonly<{
  PaxType: PaxType,
  Gender?: string,
  FirstName: string,
  SecondName?: string,
  LastName: string,
  Phone?: string,
  Email?: string,
  DocumentNumber: string,
  ConfigurationDocumentId: number,
  Nationality: string,
  DOB: string,
  FrequentFlyer: string,
  FrequentFlyerAirline: string,
  RoomNumber?: number,
  Surname?: string
}>;

export type PassengersSeats = Readonly<{
  PaxType: PaxType,
  FirstName: string,
  Surname?: string,
  SeatNumber?: string,
  State: StateSeatTypes,
  SeatNumberRemoved?: string,
  SearchId: string;
}>;

export type MultiplePassengersSeats = Readonly<{
  Name: string,
  SeatNumber?: string,
  TotalNumber: number
}>;

export type SeatMapErrors = Readonly<{
  ErrorType: SeatMapErrorsTypes,
  Title: string,
  Description: string,
  MainButtonText: string,
  SecondaryButtonText: string | null,
  FlightIdx: number
}>;

export type SeatMapTransactions = Readonly<{
  information: SavePassengers,
  isLoading: boolean,
  successful: boolean | null
}>;

export type SavePassengers = Readonly<{
  itineraryId: number,
  flightIdx: number,
  passengersSeat: PassengersSeats,
  type: TransactionTypes
}>;


export enum SeatMapErrorsTypes {
  GetItinerary = 'Initial',
  ItineraryNotAvailable = 'Initial',
  GetSeatMapFlight = 'SeatMapFlight',
  GetSeatsSeatMapFlight = 'SeatsSeatMapFlight',
  GetSeatsSeatMapFlightCheckInAirline = 'SeatsSeatMapFlightCheckInAirline',
  SeatsNotAvailableInFlight = 'SeatsNotAvailableInFlight',
  SeatsUpdateNotAvailableInFlight = 'SeatsUpdateNotAvailableInFlight',
  SeatsUpdateSucces = 'SeatsUpdateSucces'
}

export enum WingTypes {
  Initial = 'Initial',
  Normal = 'Normal',
  Final = 'Final',
  Exit = 'Exit',
  Title = 'TitleWing',
  Empty = 'Empty'
}

export enum CabinTypes {
  Business = 'C',
  First = 'F',
  Economy = 'Y',
  PremiumEconomy = 'W'
}

export enum RowDataTypes {
  Letters = 'Letters',
  Title = 'Title',
  Exit = 'Exit',
  Seat = 'Seat'
}

export enum PositionTypes {
  Window = 'Window',
  Center = 'Center',
  Aisle = 'Aisle',
  SpaceAisle = 'SpaceAisle'
}

export enum UbicationTypes {
  Right = 'Right',
  Left = 'Left'
}

export enum PaxTypeSeatMap {
  ADULT = 'ADT',
  CHILDREN = 'CHD',
  INFANTS = 'INF'
}

export enum StateSeatTypes {
  Created = 'Created',
  Removed = 'Removed',
  Origin = 'Origin',
  Error = 'Error'
}

export enum TransactionTypes {
  Reassigned = 'Reassigned',
  Update = 'Update'
}
